module.exports = __webpack_public_path__ + "img/aderhold-h-474x356.91c4be94.jpg";